import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { optional } from 'teacher-ui-client/helpers/optional'
import { InputText } from 'teacher-ui-client/components/base/input-text'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLInputElement
  Args: {
    id: string
    value?: string
    name: string
    themeKey?: ThemeKeys
    outlineForced?: boolean
    onInput: (event: Event & { target: HTMLInputElement }) => void
    onFocusOut: () => void
  }
}

export const FormFieldInput: TOC<Signature> = <template>
  {{! This component only exists as a workaround for the (component) helper not yet supporting applying html attributes to a component }}
  {{! Any component properties you want to use, you'll need to specify here to pass onwards }}
  <InputText
    id={{@id}}
    class="block w-full"
    value={{@value}}
    name={{@name}}
    autocomplete="off"
    @themeKey={{@themeKey}}
    @outlineForced={{@outlineForced}}
    {{on "input" (optional @onInput)}}
    {{on "focusout" (optional @onFocusOut)}}
    ...attributes
  />
</template>

export default FormFieldInput
